import { apiFetch } from '~/utils/apiFetch'
import {
  SECURITY_LOGS_PAGE_SIZE,
  type ChangeFundPasswordRequestDto,
  type ChangePasswordRequestDto,
  type EmailBindRequestDto,
  type ForgotFundPasswordCodeRequestDto,
  type ListLoginDevicesResponseDto,
  type ListSecurityLogsQuery,
  type ListSecurityLogsResponseDto,
  type PhoneBindRequestDto,
  type ResetFundPasswordRequestDto,
  type SecurityEmailCodeRequestDto,
  type SecurityPhoneCodeRequestDto,
  type SetFundPasswordRequestDto,
  type VerifyFundPasswordRequestDto,
  type FundPasswordVerifyResponseDto,
} from '~/types/api/security'

/** POST /api/v1/account/password/change — 已登录玩家修改登录密码 */
export function changePassword(payload: ChangePasswordRequestDto) {
  return apiFetch<unknown>('/account/password/change', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/email/verification-code — 换绑邮箱发送验证码 */
export function sendSecurityEmailCode(payload: SecurityEmailCodeRequestDto) {
  return apiFetch<unknown>('/account/security/email/verification-code', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/email/bind — 绑定 / 更换登录邮箱 */
export function bindEmail(payload: EmailBindRequestDto) {
  return apiFetch<unknown>('/account/security/email/bind', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/phone/verification-code — 换绑手机发送验证码 */
export function sendSecurityPhoneCode(payload: SecurityPhoneCodeRequestDto) {
  return apiFetch<unknown>('/account/security/phone/verification-code', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/phone/bind — 绑定 / 更换登录手机 */
export function bindPhone(payload: PhoneBindRequestDto) {
  return apiFetch<unknown>('/account/security/phone/bind', {
    method: 'POST',
    body: payload,
  })
}

/** GET /api/v1/account/security/devices — 登录设备列表（未下线会话，按登录时间倒序） */
export function listLoginDevices() {
  return apiFetch<ListLoginDevicesResponseDto>('/account/security/devices')
}

/** GET /api/v1/account/security/logs — 安全记录（按发生时间倒序，默认每页 10 条） */
export function listSecurityLogs(query?: ListSecurityLogsQuery) {
  return apiFetch<ListSecurityLogsResponseDto>('/account/security/logs', {
    query: { page_size: SECURITY_LOGS_PAGE_SIZE, ...query },
  })
}

/** POST /api/v1/account/security/devices/{session_id}/revoke — 下线指定登录设备 */
export function revokeLoginDevice(sessionId: string) {
  return apiFetch<unknown>(`/account/security/devices/${encodeURIComponent(sessionId)}/revoke`, {
    method: 'POST',
  })
}

/** POST /api/v1/account/security/fund-password/set — 首次设置资金密码 */
export function setFundPassword(payload: SetFundPasswordRequestDto) {
  return apiFetch<unknown>('/account/security/fund-password/set', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/fund-password/change — 修改资金密码 */
export function changeFundPassword(payload: ChangeFundPasswordRequestDto) {
  return apiFetch<unknown>('/account/security/fund-password/change', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/fund-password/forgot/verification-code — 忘记资金密码发码 */
export function sendForgotFundPasswordCode(payload: ForgotFundPasswordCodeRequestDto) {
  return apiFetch<unknown>('/account/security/fund-password/forgot/verification-code', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/fund-password/forgot/reset — 忘记资金密码重置 */
export function resetFundPassword(payload: ResetFundPasswordRequestDto) {
  return apiFetch<unknown>('/account/security/fund-password/forgot/reset', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/security/fund-password/verify — 验证资金密码 */
export function verifyFundPassword(payload: VerifyFundPasswordRequestDto) {
  return apiFetch<FundPasswordVerifyResponseDto>('/account/security/fund-password/verify', {
    method: 'POST',
    body: payload,
    skipErrorToast: true,
  })
}
